import { formatBytes, truncateFileName } from "../../../helpers";

const ReplyMessage = ({
  replyingTo,
  userInfo,
  validPreviewExtensions,
  documentPreviewIcon,
}) => {
  if (!replyingTo) return null;

  const sender = replyingTo.uid === (userInfo?.uid ?? "");

  return (
    <div
      onClick={() => {
        const element = document.getElementById(replyingTo.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }}
      className="d-flex"
      style={{ marginBottom: "12px" }}
    >
      <div
        className={`message-reply ${
          sender ? "message-recipient" : "message-author"
        }`}
        style={{
          boxShadow: sender ? "0px 0px 2px 2px white" : "0px 0px 2px 2px white",
        }}
      >
        <div>
          {replyingTo.body.files.length !== 0 && (
            <div>
              {replyingTo.body.files.map((file, idx) => {
                if (idx > 0) {
                  return null;
                }
                const filenameWithoutParams = file.url.replace(/\?.*$/, "");
                return (
                  <div
                    key={idx}
                    className={`send-chatbar-media-container ${
                      sender ? "media-recipient" : "media-author"
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="preview-div">
                      <img
                        alt={"file preview"}
                        src={
                          validPreviewExtensions.some((extension) =>
                            filenameWithoutParams.endsWith(extension),
                          )
                            ? file.url
                            : documentPreviewIcon
                        }
                      />
                    </div>
                    <div
                      className={`no-url${sender ? "-recipient" : "-author"}`}
                    >
                      <div className="information-div">
                        {truncateFileName(
                          decodeURI(
                            filenameWithoutParams.replace(/^.*(%2F|\/)/, ""),
                          ),
                        )}
                        <h3>{formatBytes(file.size)}</h3>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div
            className="message-reply-text"
            style={{ color: sender ? "black" : "white" }}
          >
            {Array.isArray(replyingTo.body.message) ? (
              <div>
                {replyingTo.body.message.map((item, index) => (
                  <span key={index}>{item} </span>
                ))}
              </div>
            ) : (
              <div style={{ whiteSpace: "nowrap" }}>
                {replyingTo.body.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplyMessage;
